import { Link } from "react-router-dom";

const footerNav = [
  { label: "首页", to: "/" },
  { label: "剧情介绍", to: "/category/story" },
  { label: "演员名单", to: "/category/cast" },
  { label: "精彩片段", to: "/category/clip" },
  { label: "关于本站", to: "/about" },
];

const friendLinks = ["影视资料库", "追剧指南", "剧评社区", "幕后花絮站"];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-secondary-900 text-background-100">
      <div className="mx-auto grid w-full max-w-[1280px] gap-8 px-4 py-12 md:grid-cols-3 md:px-6">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg text-background-50">
              母
            </span>
            <span className="font-heading text-lg font-semibold text-background-50">年轻的母亲</span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200">
            “年轻的母亲”影视剧专题站，聚焦剧情介绍、演员资料与精彩片段，陪你重新读懂这部剧里的每一个瞬间。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-medium text-background-50">站内导航</h4>
          <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
            {footerNav.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="text-background-200 transition hover:text-accent-400">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-medium text-background-50">友情链接</h4>
          <ul className="mt-4 flex flex-wrap gap-2 text-sm">
            {friendLinks.map((item) => (
              <li key={item}>
                <span className="inline-block rounded-full bg-background-50/10 px-3 py-1 text-background-200">
                  {item}
                </span>
              </li>
            ))}
          </ul>
          <p className="mt-5 text-xs leading-relaxed text-background-300">
            本站为影视专题演示站，剧情、演员与片段内容均为虚构示例，仅用于展示与交流。
          </p>
        </div>
      </div>
      <div className="border-t border-background-50/10">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-300 sm:flex-row md:px-6">
          <span>© 2024 年轻的母亲影视专题站 · 演示用途</span>
          <span>内容仅供影视爱好者交流与学习</span>
        </div>
      </div>
    </footer>
  );
}